import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { DeviceStatus } from '../types';

interface DeviceStatusBadgeProps {
  status: DeviceStatus;
}

export function DeviceStatusBadge({ status }: DeviceStatusBadgeProps) {
  const { t } = useTranslation();

  const getStatusColor = () => {
    switch (status) {
      case 'ACTIVE':
        return 'bg-blue-500 hover:bg-blue-600';
      case 'BLOCKED':
        return 'bg-red-500 hover:bg-red-600';
      default:
        return 'bg-gray-500 hover:bg-gray-600';
    }
  };

  return (
    <Badge className={`rounded-full text-white ${getStatusColor()}`}>
      {t(`status.${status}`)}
    </Badge>
  );
}
